import React from 'react';
import styled from 'styled-components';
import MediaQuery from 'react-responsive';
import Button from '../../components/button/Button';
import { Card } from '../../components/ui/Card';
import fill from 'lodash/fill';
import withLocalized from '../../../localization/withLocalized';

const LoadMoreButton = styled(Button)`
  margin: 2.125rem auto 3.125rem !important;
`;

const LoadMoreButtonWrap = styled.div`
  width: 100%;
  align-self: center;
  text-align: center;
`;

const PlaceholderWrap = styled.div`
  display: flex;
  //flex: 1 0;
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: 320px;
  justify-content: space-between;
`;

const PlaceholderCard = styled(Card)`
  border: transparent !important;
  box-shadow: none !important;
`;

const List = (props) => {
  const {
    Container = 'div',
    items,
    renderItem,
    hasNextPage,
    pageCount,
    onLoadMoreClick,
    localized,
  } = props;

  const isLastPage = !hasNextPage;
  return (
    <Container>
      {items.map(renderItem)}
      {isLastPage && items.length % 2 ? (
      <MediaQuery minWidth={768} component={PlaceholderWrap}>
        {fill(Array(2 - items.length % 2), 0).map((item, index) => <PlaceholderCard key={index} />)}
      </MediaQuery>
      ) : null}

      {isLastPage && items.length % 3 ? (
      <MediaQuery minWidth={1024} component={PlaceholderWrap}>
        {fill(Array(3 - items.length % 3), 0).map((item, index) => <PlaceholderCard key={index} />)}
      </MediaQuery>
      ) : null}

      {onLoadMoreClick && pageCount > 0 && !isLastPage && (
        <LoadMoreButtonWrap>
          <LoadMoreButton inverse onClick={onLoadMoreClick}>{localized('search.results.label_load_more')}</LoadMoreButton>
        </LoadMoreButtonWrap>
      )}
    </Container>
  );
};

export default withLocalized(List);



// WEBPACK FOOTER //
// ./src/modules/common/components/list/List.js